import React, { useEffect, useState } from 'react'
import { request } from '../../Utils/request';
import { useParams } from 'react-router-dom';
import ReviewCard from '../../Components/ReviewCard';
import { Typography } from '@mui/material';

const AllReviews = () => {
    const { id } = useParams()
    useEffect(() => {
        const fetchReviews = async () => {
            const res = await request<{ success: boolean, data: any[] }>(`/places/${id}/reviews`, {
                authorization: true,
            });
            setReviews(res.data)
        }
        fetchReviews()
    }, [id])
    const [reviews, setReviews] = useState<any>({})
    return (
        <div>
            <Typography variant="h6" fontWeight="600" sx={{ my: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                Reviews
            </Typography>
            {reviews?.reviews?.map((rev: any) => (
                <ReviewCard
                    key={`${rev.user._id}-${rev.ratedAt}`}
                    userName={rev.user.username}
                    avatar={rev.user?.profilePhoto?.url || ''}
                    date={rev.ratedAt}
                    rating={rev.rating}
                    review={rev.review}
                />
            ))}
        </div>
    )
}

export default AllReviews